import produce from 'immer';
import { SET_ERROR, TOGGLE_LOADING, SET_FREE_SPINS, SET_BONUS_DETAILS } from './actions';

export const defaultState = {
    freeSpinsBalance: [],
    bonusDetails: {},
    isLoading: true,
    error: ''
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_FREE_SPINS:
        case SET_FREE_SPINS + reducerSuffix: {
            Object.assign(draftState, {
                freeSpinsBalance: action.payload
            });

            break;
        }

        case SET_BONUS_DETAILS:
        case SET_BONUS_DETAILS + reducerSuffix: {
            const { id, bonusDetails, isLoading, error } = action.payload;

            Object.assign(draftState, {
                bonusDetails: {
                    ...draftState.bonusDetails,
                    [id]: {
                        error,
                        isLoading,
                        ...bonusDetails
                    }
                }
            });

            break;
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        case SET_ERROR:
        case SET_ERROR + reducerSuffix: {
            const { error } = action.payload;

            Object.assign(draftState, {
                error
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
